import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import CounterSection from "@/components/CounterSection";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import Portfolio from "@/components/Portfolio";
import BabyShower from "@/components/BabyShower";
import Birthdays from "@/components/Birthdays";
import AdultBirthday from "@/components/AdultBirthday";
import HowItWorks from "@/components/HowItWorks";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import ScrollReveal from "@/components/ScrollReveal";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen">
      <Header />
      <Hero />
      <ScrollReveal><About /></ScrollReveal>
      <CounterSection />
      <ScrollReveal delay={0.05}><Services /></ScrollReveal>
      <ScrollReveal><Gallery /></ScrollReveal>
      <ScrollReveal delay={0.05}><Manifesto /></ScrollReveal>
      <ScrollReveal><Testimonials /></ScrollReveal>
      <ScrollReveal delay={0.05}><Portfolio /></ScrollReveal>
      <ScrollReveal><BabyShower /></ScrollReveal>
      <ScrollReveal delay={0.05}><Birthdays /></ScrollReveal>
      <ScrollReveal><AdultBirthday /></ScrollReveal>
      <ScrollReveal delay={0.05}><HowItWorks /></ScrollReveal>
      <FinalCTA />
      <Footer />
      <FloatingButtons />
    </div>
  );
}
